module.exports = __webpack_public_path__ + "img/archive-active.02b87704.svg";